export default {
  'app.editor.flow.title': 'Flowchart Editor',
  'app.editor.flow.description':
    'The flow chart is an excellent way to represent the idea of the algorithm.',
  'app.editor.koni.title': 'Koni Editor',
  'app.editor.koni.description':
    'The topology diagram refers to the network structure diagram composed of network node devices and communication media.',
  'app.editor.mind.title': 'Mind Map Editor',
  'app.editor.mind.description':
    'The brain map is an effective graphical thinking tool for expressing divergent thinking. It is simple but effective and is a practical thinking tool.',
};
